var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalindustrialProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd97b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26517,
    stopColor: "#c94673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#d50037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99468,
    stopColor: "#540037"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.21349,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.53446,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.44117,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.5177,52.04055c-.33493,1.78628-.84849,3.43859-1.42903,4.93461h4.75598c-.69218-1.96492-1.85327-3.61723-3.32695-4.93461h0ZM59.8941,67.91614c-.98246.80383-1.94258,1.49601-2.92504,2.12121,4.68899-.98245,10.874-2.70175,15.98724-5.60447h0c.33493-1.0941.51356-2.29984.51356-3.55024,0-.58054-.06699-1.13876-.11164-1.7193h-6.31898c-1.98724,3.86284-4.62201,6.74322-7.14513,8.75279ZM65.67719,56.97516c.84849-2.00957,1.49601-4.13078,1.83094-6.36363h0c-1.7193-.98245-3.72887-1.54067-5.85008-1.54067-5.15789,0-9.51196,3.25997-11.11961,7.9043h15.13875ZM60.69793,71.3994c-.98246.22329-1.89793.4689-2.74641.6252h0c1.20574.40191,2.41148.6252,3.72887.6252,3.95215,0,7.4354-1.94259,9.55661-4.93461-2.99202,1.45136-6.54226,2.70175-10.53907,3.68422ZM53.59745,69.45681h0c1.54067-.80383,3.25997-1.89793,4.97926-3.32695,2.45614-2.00957,4.46571-4.35407,5.96172-6.98883h-14.49122c-.06699.58054-.11164,1.13876-.11164,1.7193-.02233,3.3716,1.36204,6.40829,3.66188,8.59648Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalindustrialProductsScraper);
export default __webpack_public_path__ + "static/media/globalindustrial-products-scraper.69c873fd2c196ad2d1f4781eaee784b1.svg";
export { ForwardRef as ReactComponent };